import { attachCandidateActions as actions } from './attachCandidateActions';
import { attachCandidateReducer as reducer } from './attachCandidateReducer';
import { attachCandidateSelectors as selectors } from './attachCandidateSelectors';

export { actions, reducer, selectors };
